import React, { useEffect } from 'react';
import styles from './index.module.css';

declare global {
  interface Window {
    Ya: any;
  }
}

type YandexShareProps = {
  id: string;
  color?: string;
}

export const YandexShare: React.FC<YandexShareProps> = ({ ...props }) => {
  const { id, color } = props;

  useEffect(() => {
    const YaShare = window.Ya || {};
    try {
      YaShare.share2(`ya-${id}`, {
        theme: {
          services: 'facebook,odnoklassniki,telegram,twitter,vkontakte',
          shape: 'round',
          'color-scheme': 'whiteblack',
          lang: 'ru',
          limit: 5,
          size: 'm',
          bare: false
        },
        content: {
          url: window.location.href
        }
      });
    } catch (e) { };
  }, [window.Ya]);

  return (
    <div
      className={`
        ${id === 'mobile' ? `${styles['ya-share2-mobile']} mb-4 w-full max-w-xsxs` : ``}
        ${styles['ya-share2-horizontal']}
        ${color ? styles['ya-share2-light'] : ``}
      `}
    >
      <div id={`ya-${id}`} />
    </div>
  );
}
